// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__stDOl","clinicsSelect":"TableHeading_clinicsSelect__2Tp-J"};